var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDownloadOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33338 10.6667C4.50202 10.6672 3.70045 10.3571 3.08596 9.79713C2.47147 9.23716 2.08841 8.46778 2.01194 7.63995C1.93547 6.81211 2.17111 5.98558 2.67262 5.32252C3.17413 4.65947 3.90532 4.20775 4.72271 4.056C4.86628 3.29178 5.27241 2.60176 5.87086 2.10527C6.46931 1.60878 7.22245 1.33703 8.00004 1.33703C8.77763 1.33703 9.53078 1.60878 10.1292 2.10527C10.7277 2.60176 11.1338 3.29178 11.2774 4.056C12.092 4.21083 12.8198 4.66365 13.3186 5.32608C13.8174 5.98851 14.0515 6.81303 13.9753 7.63876C13.899 8.46448 13.5178 9.23217 12.9061 9.79201C12.2943 10.3519 11.4959 10.6637 10.6667 10.6667M6.00004 12.6667L8.00004 14.6667M8.00004 14.6667L10 12.6667M8.00004 14.6667V6.66667",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloadOutline);
export default __webpack_public_path__ + "static/media/CloudDownloadOutline.a38ad4ca9b8126c76a67ce76a0618295.svg";
export { ForwardRef as ReactComponent };